/**
 * Defaults the collection "In stock" filter to checked on a fresh page
 * landing (no filter params in the URL), while staying fully removable.
 *
 * The in-stock checkbox is staged (not applied) like every other filter on
 * this theme, so we just need to: (1) check the box and let theme.js's own
 * change handling pick up the state for the chip/count UI and for the real
 * navigation when "Apply Filters" is clicked, and (2) remember it if the
 * shopper explicitly turns it off, so it doesn't silently come back this
 * session.
 */
(function () {
  const STORAGE_KEY = 'foray:availabilityDefault';

  function hasAvailabilityParam() {
    const checkbox = document.querySelector('[data-filter-availability-instock]');
    if (!checkbox) return true;
    const params = new URLSearchParams(window.location.search);
    return Array.from(params.keys()).some((key) => key === checkbox.name);
  }

  function applyDefault() {
    const checkbox = document.querySelector('[data-filter-availability-instock]');
    if (!checkbox || checkbox.checked) return;
    if (hasAvailabilityParam()) return;
    if (sessionStorage.getItem(STORAGE_KEY) === 'off') return;

    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindPersistence() {
    const form = document.querySelector('[data-filter-form]');
    if (!form) return;

    form.addEventListener('submit', () => {
      const checkbox = document.querySelector('[data-filter-availability-instock]');
      if (!checkbox) return;
      sessionStorage.setItem(STORAGE_KEY, checkbox.checked ? 'on' : 'off');
    });
  }

  applyDefault();
  bindPersistence();
})();
